import { takeEvery } from 'redux-saga/effects';
import { findGenerator } from 'helpers/resourceSagas';
import * as types from './types';
import * as api from './api';

export const findCurrent = findGenerator({
  resourceType: 'quickUsage',
  endpoint: api.findCurrent,
  endpointArgs: (payload) => [payload.subId],
  transformResponse: (resp, args) => {
    const usage = resp.data;
    return [{
      ...usage,
      id: args[0]
    }]
  },
});

export function* watchUsage() {
  yield takeEvery(types.FIND_CURRENT, findCurrent);
}

